/**
 * @author Harshitha.k
 * @description 
 */

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Select, Form } from 'antd';
import { connect } from 'react-redux';
import localStorage from '../../../../utils/localStorage';
import { API_ROLE, API_SITE } from '../../../../commons/api';

const { Option } = Select;

const SiteRoleComponent = ({ site, index, editObj, handleFieldChange, translationCache }) => {
  const [siteList, setSiteList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [currentSite, setCurrentSite] = useState(site);

  useEffect(() => {
    _getSiteList();
    _getRolesList(site.SiteId);
  }, []);

  useEffect(() => {
    if (editObj !== currentSite) {
      setCurrentSite(site);
      _getRolesList(site.SiteId);
    }
  }, [editObj, site]);

  const _getSiteList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const orgHeaders = {
      method: 'GET',
      url: `${API_SITE.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    axios(orgHeaders)
      .then((response) => {
        setSiteList(response.data);
      })
      .catch(() => { });
  };

  const _getRolesList = () => {
    const accessToken = localStorage.get('accessToken');
    const SiteId = localStorage.get('currentSite');

    const orgHeaders = {
      method: 'GET',
      url: `${API_ROLE.GET}?SiteId=${SiteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    axios(orgHeaders)
      .then((response) => {
        setRoleList(response.data);
      })
      .catch(() => { });
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Form.Item label={translation('SiteName')}>
        <Select
          value={currentSite.SiteId || undefined}
          openOnFocus
          style={{ width: 160 }}
          onChange={(e) => handleFieldChange(e, 'SiteId', index)}
          placeholder="Site"
        >
          {Array.isArray(siteList) && siteList.map((siteItem, idx) => (
            <Option key={idx} value={siteItem.Id}>
              {translation(siteItem.Name)}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label={translation('Role')}>
        <Select
          mode="multiple"
          value={currentSite.RoleId}
          openOnFocus
          style={{ width: 200 }}
          onChange={(e) => handleFieldChange(e, 'RoleId', index)}
          placeholder={translation('Role')}
        >
          {Array.isArray(roleList) && roleList.map((roleItem, idx) => (
            <Option key={idx} value={roleItem.Id}>
              {roleItem.Name}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(SiteRoleComponent);